import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from "reactstrap";

import { templateApi } from '../../reducers/templateSlice';

const NewTemplatePopup = ({ area, template, onToggle }) => {
    const [name, setName] = useState(template ? template.name : "")
    const dispatch = useDispatch()

    useEffect(() => {
        setName(template ? template.name : "")
    }, [template])

    const onModalToggle = () => {
        onToggle()
    }

    const onSave = () => {
        if(name && name.length > 0) {
            if(template) {
                dispatch(templateApi.update({ 
                    areaId: area.id,
                    template: {
                        ...template, name: name
                    }
                }))
            } else {
                dispatch(templateApi.create({ 
                    areaId: area.id,
                    template: {
                        name: name
                    }
                }))
            }
        }
        onToggle()
    }

    return (
        <Modal
            isOpen={true}
            toggle={() => { onModalToggle() }}
        >
            <ModalHeader toggle={() => { onModalToggle() }}>
                <b>Nuovo template</b>
            </ModalHeader>
            <ModalBody>
                <Input value={name} onChange={(event) => setName(event.target.value)}/>
            </ModalBody>
            <ModalFooter>
                <Button id="new_template_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { onSave() }} >
                    <span className="fas fa-check"></span> SALVA
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default NewTemplatePopup;